/**
 * User Management is one fixed "Users" tab plus one tab per OG user group that
 * GetOgUserGroups returns, so a role the admin adds through User Role
 * Configuration becomes a tab without a code change. Group tabs are keyed by
 * the group's `id` — role names can be edited, ids cannot.
 */
export const USERS_TAB_KEY = "users";

export const USERS_TAB_LABEL = "Users";

/** `"users"` for the all-users tab, otherwise the OG group's `id`. */
export type TabKey = typeof USERS_TAB_KEY | number;

/**
 * The "Move To" option that takes a user out of every OG group (roleId: null).
 * Every other option in that modal is a real group, labelled and described by
 * whatever GetOgUserGroups returns.
 */
export const NO_OG_GROUP_LABEL = USERS_TAB_LABEL;
export const NO_OG_GROUP_DESCRIPTION = "Standard users without OG benefits.";

/** `freeTokenAmount` is null when the group's free tokens are uncapped. */
export const formatFreeTokenAmount = (amount: number | null): string =>
  amount === null || amount === undefined ? "Unlimited" : String(amount);
